import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import elephant from 'assets/img/stock/botswana/gamedrive.jpg';

export default () =>
    <div className="fullheight">
        <Navbar className="dark_start" />

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="col-md-12 bordered_block grey_border image_bck m-t-120 p-t-30"
                        data-image={elephant}
                    >
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 wow fadeInLeft">
                                    <span className="great_title">
                                        Okavango
                                    </span>
                                    <span className="great_subtitle great_subtitle_big" />
                                    <br />
                                    <span className="into_txt" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <table className="table table-bordered table-striped dark-text">
                            <thead>
                                <tr>
                                    <th>Town</th>
                                    <th>Activities</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Kasane, Botswana</td>
                                    <td>
                                        <ul>
                                            <li>Chobe Safari</li>
                                            <li>Canoing on Chobe River</li>
                                            <li>Bird Watching</li>
                                            <li>
                                                Local village people and
                                                cultures excursion
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/itinerary/okavango/OkavangoItinerary.jsx